import React from 'react';
import PropTypes from "prop-types";
import { Icon, Select } from 'antd';
import unionIcon from '../../../assets/images/warehouse.svg'
import switcher from '../../../assets/images/switcher.svg'

function WarehouseSelector (props) {
  const {
    isFetchingWarehouses,
    isWarehouseMultiSelect,
    warehouses,
    isDisabled,
    style,
    handleWarehouseChange,
    defaultSelectionValue,
    getWarehouse,
    showIcon=false,
    showAllOption = true,
    faceValue="name",
  } = props;

  const switcherSvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6.59961L8.80005 9.79961H15.2L12 6.59961ZM8.80005 14.1996L12 17.3996L15.2 14.1996H8.80005Z" fill="#576EC1"/>
</svg>
  );

  const renderSelectedValue = (value) => {
    if (!value) return 'Select an option'; // Placeholder when no item is selected
    return (
      <span>
        <img src={unionIcon} style={{ width: 20, marginRight: 5 }} />
        {value}
      </span>
    );
  };


  return (
    <Select
      loading={ isFetchingWarehouses }
      value={
        getWarehouse()
      }
      className='custom-select'
      //prefixIcon={ showIcon ? <Icon type="home" /> : null }
      suffixIcon={ showIcon ? <Icon component={switcherSvg} style={{  marginTop: -6, marginRight: 0, height: 24 }}/> : null }
      disabled={ isDisabled }
      labelInValue={ isWarehouseMultiSelect }
      showSearch
      showArrow
      style={ style ? style : { width: "250px" } }
      filterOption={(input, option) => {
        const label = option?.props?.children || option?.props?.label || "";
        return String(label).toLowerCase().includes(input.toLowerCase());
      }}
      mode={ isWarehouseMultiSelect ? "multiple" : "default" }
      maxTagCount={ 1 }
      onChange={ handleWarehouseChange }
      optionLabelProp="label" 
      size='large'
      dropdownMatchSelectWidth={false}
    >
      {
        showAllOption && <Select.Option key="" value="">
        { defaultSelectionValue }
      </Select.Option>
      }
      { warehouses.sort((a, b) => a.name.localeCompare(b.name)).map((warehouse) => (
        <Select.Option
          key={ warehouse.location_code }
          value={ warehouse.id }
          label={faceValue === 'location_code' ? warehouse[faceValue] : renderSelectedValue(warehouse[faceValue])}
        >
          { warehouse[faceValue] }
        </Select.Option>
      )) }
    </Select>
  );
}

export default WarehouseSelector

WarehouseSelector.defaultProps = {
  isWarehouseMultiSelect: false,
  isDisabled: false,
  style: {},
  defaultSelectionValue : "-- All --",
  handleWarehouseChange: () => { },
  isFetchingWarehouses : false,
  getWarehouse : () => { }
}

WarehouseSelector.propTypes = {
  isFetchingWarehouses: PropTypes.bool,
  isWarehouseMultiSelect: PropTypes.bool,
  warehouses: PropTypes.array,
  isDisabled: PropTypes.bool,
  style: PropTypes.object,
  handleWarehouseChange: PropTypes.func,
  defaultSelectionValue: PropTypes.string,
  getWarehouse : PropTypes.func,
  showAllOption : PropTypes.bool,
}